import { render, staticRenderFns } from "./LeftPostBasicEdit.vue?vue&type=template&id=4c9d1ab6&scoped=true&"
import script from "./LeftPostBasicEdit.vue?vue&type=script&lang=js&"
export * from "./LeftPostBasicEdit.vue?vue&type=script&lang=js&"
import style0 from "./LeftPostBasicEdit.vue?vue&type=style&index=0&id=4c9d1ab6&scoped=true&lang=sass&"
import style1 from "./LeftPostBasicEdit.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9d1ab6",
  null
  
)

export default component.exports